import { Component } from "react";
import { Tab, Tabs } from "react-bootstrap";
import TwTabs from "./twTabs";
import NeedHelp from '../Elements/NeedHelp';
import { createFeedAction } from "../../../../../../actions/addFeedActions";
import { connect } from "react-redux";
import { getInitialRoute, showAddAccountAlertNew, isAppleSafari} from "../../../../../../utils";
import SubmitFeedRequest from "../Elements/SubmitFeedRequest";
import { addUserAccount } from "../../../../../Authorization/SocialAuth/connectSocialAcc";
import { toast } from "react-toastify";

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class TwitterFeed extends Component {
    state = {
        hashtag: '',
        handle: '',
        mentions: '',
        advanced: '',
        userName: '',
        listName: '',
        favorites: '',
        userId: null,
        listId: null,
        filter: null,
        filterType: 'hashtag',
        showError: false, 
        handleError: false,
        mentionError: false,
        advanceError: false,
        favoriteError: false,
        showListError: false,
        listNameError: false,
        connetedAccount: null,
        authRequired: null,
        moderation: false,
        multiplePhoto: true,
        excludeRetweet: true,
        excludeReplies: true,
        isLoading: false,
    }

    componentDidMount() {
        this.setState({ authRequired: this.props.feedInfo[0].authRequire })
        this.props.onFilterNameChange(this.state.filterType);
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    onModerationChange = (e) => this.setState({ [e.target.name]: e.target.checked })

    onChangeHandler = event => {
        this.setState({ [event.target.name]: event.target.value, error: false, handleError: false, showError: false, mentionError: false, advanceError: false, favoriteError: false, listNameError: false, showListError: false });
    }


    onListNameChange = (value) => this.setState({ listname: value, showListError: false })
    onConnectedAccountChange = (value) => this.setState({ connetedAccount: value })
    onListIdChange = (listId, userId) => this.setState({ listId: listId,userId: userId })


    onAddAccount = () => {
        showAddAccountAlertNew({id:1,name:"twitter"},"addFeed");
    }
    createFeed = (connectAccountId) => {
        const { hashtag, handle, excludeRetweet, excludeReplies, multiplePhoto, userId, listId, listName, userName, advanced, mentions, favorites, moderation,authRequired,filterType } = this.state;
        const { wallId, feedInfo,hideAddfeed,navigation } = this.props;

        const index = feedInfo && feedInfo.length && feedInfo[0].networkTab && feedInfo[0].networkTab.length ? feedInfo[0].networkTab.findIndex(f => f.feedtype == filterType) : null
        const selectedFilterId = feedInfo[0].networkTab[index].filter;
        var obj = {
            wallId:wallId,
            networkId: 1,
            filter: selectedFilterId,
            moderation: moderation ? 1 : 0,
            excludeRetweet: excludeRetweet ? 1 : 0,
            excludeReplies: excludeReplies ? 1 : 0,
            multiplePhoto: multiplePhoto ? 1 : 0,
            authRequire: authRequired ? 1 : 0,
            accountId: connectAccountId
        }

        if (selectedFilterId == 2) {
            obj['feedText'] =  hashtag.split('#').join('')
        } else if (selectedFilterId == 1) {
            obj['feedText'] =  handle.split('@').join('')
        } else if (selectedFilterId == 7) {
            obj['feedText'] = mentions
        } else if (selectedFilterId == 4) {
            obj['feedText'] = favorites
        } else if (selectedFilterId == 5) {
            obj['feedText'] = advanced
        } else if (selectedFilterId == 3) {
            obj['feedText'] = userName;
            obj['listname'] = listName;
            obj['userId'] = userId;
            obj['listId'] = listId;
        }
        this.setState({ isLoading: true, error: false, handleError: false, mentionError: false, advanceError: false, favoriteError: false, listNameError: false, showError: false, showListError: false  });

        createFeedAction(obj,1,(feedId)=>this.setState({isLoading:false},()=>{
            if(feedId){
                hideAddfeed();
                navigation(`/moderation/index/${wallId}`);
            }
        }))

    }

    submit = () => {
        const { hashtag, advanced, handle, userName, listName, favorites, mentions, filterType, authRequired } = this.state;
        const { accountId, createdFeeds, userData } = this.props;
       

        if (filterType == 'hashtag' && hashtag.trim().length == 0) {
                this.setState({ showError: true}); 
        } else if (filterType == 'handle' && handle.trim().length == 0) {
            this.setState({ handleError: true });
        } else if (filterType == 'mentions' && mentions.trim().length == 0) {
            this.setState({ mentionError: true });
        } else if (filterType == 'favorites' && favorites.trim().length == 0) {
            this.setState({ favoriteError: true });
        } else if (filterType == 'advanced' && advanced.trim().length == 0) {
            this.setState({ advanceError: true});
        } else if (filterType == 'list' && userName.trim().length == 0) {
            this.setState({ showListError: true});
        } else if (filterType == 'list' && listName.trim().length == 0) {
            this.setState({ listNameError: true});
        } else {

            this.setState({showError:false});

            if(userData && Object.keys(userData).length > 0 && userData.UserRule && Object.keys(userData.UserRule).length > 0){
               const twitterFeeds = createdFeeds.reduce((acc, curr) => { if(curr.networkId == 1) acc++; return acc; }, 0);
                if(!isNaN(userData.UserRule.twitterFeedLimit) && twitterFeeds >= userData.UserRule.twitterFeedLimit){
                    toast.error('Twitter feed limit exhausted!!!', { autoClose: 3000 })
                    return;
                }
            }

            if (authRequired) {
                if (accountId == null) {
                    this.onAddAccount();
                } else {
                    this.createFeed(accountId);
                }
            } else {
                const connectedAccountId = accountId ? accountId : 0;
                this.createFeed(connectedAccountId);
            }
        }
    }

    needSupportLinks = (filterType) => {
        if (getInitialRoute() === 'widget') {
            switch (filterType) {
                case 'hashtag':
                    return ['https://vimeo.com/510156339/f58e002089', 'https://taggbox.com/support/embed-twitter-hashtag-feeds-on-website/']
                case 'handle':
                    return ['https://vimeo.com/510194067/a59dfefb90', '']
                case 'mentions':
                    return ['https://vimeo.com/510194995/f2c2b8a78e', '']
                case 'list':
                    return ['https://vimeo.com/510157717/2a9f852f82', '']
                case 'favorites':
                    return ['https://vimeo.com/715471629', '']
                case 'advanced':
                    return ['https://vimeo.com/715472625', '']
                default:
                    return ['https://vimeo.com/510156339/f58e002089', 'https://taggbox.com/support/embed-twitter-hashtag-feeds-on-website/']
            }
        } else {
            switch (filterType) {
                case 'hashtag':
                    return ['https://vimeo.com/536766687/01cac2ad62', '']
                case 'handle':
                    return ['https://vimeo.com/537121043/86c97ccfd6', '']
                case 'mentions':
                    return ['https://vimeo.com/537582165/dedc409401', '']
                case 'list':
                    return ['https://vimeo.com/537585381/956f881426', '']
                case 'favorites':
                    return ['https://vimeo.com/537586243/f8f77e3995', '']
                case 'advanced':
                    return ['https://vimeo.com/536766687/01cac2ad62', '']
                default:
                    return ['https://vimeo.com/536766687/01cac2ad62', '']
            }
        }
    }
    
    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId,type} = response;
        if (type == "addFeed") {
        addUserAccount(networkId, data, (connectAccountId) => this.createFeed(connectAccountId),localStorage.getItem('ownerId'));
        }
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    render() {
        const { feedInfo, networkId, connectedAcc, onBack } = this.props
        const { isLoading, filterType} = this.state

        return (
            <>
                {feedInfo && feedInfo.length && feedInfo[0].networkTab && feedInfo[0].networkTab.length ? <div className="row">
                    <div className="col-md-12">
                        <div className="form-body create_feed_wt">
                            <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup">
                                <Tabs defaultActiveKey="hashtag" value={filterType} id="CreateFeedTab" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3" onSelect={e => { this.setState({ filterType: e }, () => { this.props.onFilterNameChange(e); } )}}>
                                    {feedInfo && feedInfo.length && feedInfo[0].networkTab && feedInfo[0].networkTab.length ? feedInfo[0].networkTab.map(filter => (
                                        <Tab eventKey={filter.feedtype} key={filter.filter} className="nav-link className= p-0" title={<span>{filter.feedName}</span>}>
                                            <TwTabs
                                                networkId={networkId}
                                                tab={filter.feedtype}
                                                filter={filter.filter}
                                                connectedAcc={connectedAcc}
                                                {...this.state}
                                                onListIdChange={this.onListIdChange}
                                                onConnectedAccountChange={this.onConnectedAccountChange}
                                                onCheckFieldChange={this.onModerationChange}
                                                onListNameChange={this.onListNameChange}
                                                onChangeHandler={this.onChangeHandler}
                                            />
                                        </Tab>
                                    )) : null}
                                </Tabs>
                                <div className="form-actions w-100">
                                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filterType)[0]} supportLink={this.needSupportLinks(filterType)[1]} />
                                        <SubmitFeedRequest onSubmit={this.submit} onBack={onBack} loading={isLoading} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                    :
                    null
                }
            </>
        )
    }
}



const mapStateToProps = (state) => {
    return {
        accountId: state.addFeedReducer.selectedAccount,
        connectedAcc: state.addFeedReducer.connectedAcc,
        userData: state.authenticated.userData
    }
}

export default connect(mapStateToProps, null)(TwitterFeed)